var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// elements/components/x-flat-loader.ts
import { customElement } from "lit/decorators.js";
import { ChemistryLiteElement } from "../../chemistry-lite-element.js";
var XFlatLoader = class extends ChemistryLiteElement {
  styles() {
    return [
      {
        "@keyframes slide": { "0%": { backgroundPosition: "-500px 0" }, "100%": { backgroundPosition: "468px 0" } },
        display: "block",
        flexShrink: "0",
        height: "1em",
        borderRadius: "1em",
        background: `linear-gradient(to right, ${this.colors.white} 8%, ${this.colors.neutral.shade(100)} 38%, ${this.colors.white} 54%)`,
        backgroundSize: "1000px 640px",
        animation: "slide 1.5s cubic-bezier(0.3, 0.1, 0.3, 0.85) infinite"
      }
    ];
  }
};
XFlatLoader = __decorateClass([
  customElement("x-flat-loader")
], XFlatLoader);
export {
  XFlatLoader
};
